// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__DKHQO","pagination_list":"pagination_pagination_list__h3bf1","pagination_list__content":"pagination_pagination_list__content__OnrvE"};